import mButtons from './main.vue';

export default mButtons;
